// extracted by mini-css-extract-plugin
export default {"link":"EventPopover_link__Nn5gy","icon":"EventPopover_icon__ezUJ9"};